/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";

export default function BasicSelect(props: {
  label?: string;
  values: any[];
  value: any;
  id: string;
  handleOnChange: any;
  wholeValue?: boolean;
  error?: boolean;
  disabled?: boolean;
  labelValue?: string;
}) {
  const { handleOnChange, disabled = false, id } = props;

  const handleClick = (value: any) => {
    handleOnChange(value.value);
    removeDropdown();
  };

  const toggleDropdown = (e: any) => {
    e.stopPropagation();
    const list = document.getElementById(`select-items-${id}`);
    if (list) {
      list.classList.toggle("active");
    }
  };

  const removeDropdown = () => {
    const list = document.getElementById(`select-items-${id}`);
    if (list) {
      list.classList.remove("active");
    }
  };

  const testRef: any = useRef(null);

  useEffect(() => {
    document.addEventListener("click", (event: any) => {
      const isClickInside = testRef.current?.contains(event.target);
      if (!isClickInside) {
        removeDropdown();
      }
    });
  }, []);

  useEffect(() => {
    if (props.value) {
      if (props.value === "none") {
        const button = document.getElementById(`select-button-${id}`);
        if (button) {
          button.innerText = props.labelValue ?? "";
        }
      } else {
        const index = props.values.findIndex((el) => el.value === props.value);
        const button = document.getElementById(`select-button-${id}`);
        if (button) {
          button.innerText = props.values[index].name ?? "Invalid Value";
        }
      }
    }
  }, [props.value]);

  return (
    <div
      className="select-wrapper"
      style={{ position: "relative", height: "100" }}
      id={`select-wrapper-${id}`}
    >
      {props.label ? (
        <label className={`select-label-${id}`}> {props.label} </label>
      ) : null}
      <button
        id={`select-button-${id}`}
        type="button"
        className="select-button"
        onClick={toggleDropdown}
        disabled={disabled}
        onFocus={(e) => {
          e.target.parentElement?.classList.add("on-focus");
        }}
        onBlur={(e) => {
          e.target.parentElement?.classList.remove("on-focus");
        }}
      >
        {props.labelValue}
      </button>

      <ul
        ref={testRef}
        className="select-values"
        id={`select-items-${id}`}
        style={{ width: "400px" }}
      >
        <li
          onClick={(e: any) => {
            handleClick({ value: "none", name: props.labelValue });
          }}
        >
          {props.labelValue}
        </li>
        {props.values.map((item) => (
          <li
            className="basic-select-list-item"
            key={item.value}
            onClick={(e) => {
              e.stopPropagation();
              handleClick(item);
            }}
          >
            {item.name}
          </li>
        ))}
      </ul>
    </div>
  );
}
